import Hogan from "hogan.js";
import jQuery from 'jquery';

;(function ( $, window, document, undefined ) {

    var pluginName = "scanManager";
    var defaults = {
      "url" : zmp_ajax.ajaxurl,
    };


    function ScanManager ( element, options ) {
      var _this = this;
      this.element = element;
      this.$element = $(this.element);
      this.settings = $.extend( {}, defaults, options );
      this.loading = false;
      this.$loadingdiv = this.settings.loadingdiv || $("<div class=\"loading hide\">Bezig met laden...</div>");
      this._defaults = defaults;
      this._name = pluginName;
      this.scan = {};
      this.report = {};
      this.continue_id = '';
      this.response_id = '';
      this.current_chapter=0;
      this.previous_chapter = 0;
      this.next_chapter = 0;
      this.next_chapter_no_answer = 0;
      this.current_question = 0;
      this.previous_question = 0;
      this.next_question = 0;
      this.next_question_no_answer = 0;
      this.current_answer = 50;
      this.question_type = '';

      this.init();
    }

    $.extend(ScanManager.prototype, {
      init: function () {
        var _this = this;
        this.getData();
      },
      getData : function () {
        var _this = this;
        $.ajax({
          url : this.settings.url,
          method : "GET",
          data : {
            "scan_id" : _this.$element.attr ("data-scan_id"),
            "continue_id" : _this.$element.attr ("data-continue_id"),
            "action" : "zmpzt_continue_scan",
            "scan_type" : _this.$element.attr ("data-scan_type")
          },
          dataType : "json",
          success : function(data) {

            if ("success" in data && data.success === false ){

            } else {
              //MJ: merge chapters and answers
              if ( _this.$element.attr ("data-scan_type") == "research_scan") {

                data.scan.chapter.push ( data.scan.extra_chapter );

              }
              _this.scan = data.scan;
              _this.response_id = data.response.id;

              if ( typeof data.response.answer == "object" ) {
                //MJ: load all previous states
                var current_state = {
                  "current_chapter" : 0,
                  "current_question" : 0,
                  "question_type" : _this.getQuestion(0,0).question_type
                };
                console.log(_this.getQuestion(0,0));
                for ( var answer in data.response.answer ) {
                  var new_state =  data.response.answer [ answer ].state;
                  _this.setStateForQuestion ( new_state );
                  if ( new_state.current_chapter > current_state.current_chapter || (new_state.current_chapter == current_state.current_chapter && new_state.current_question > current_state.current_question) ){
                    current_state = new_state;
                  }
                }
                console.log(current_state);
                _this.setState (current_state );
              } else {

              }

              _this.calculateState ();
              _this.renderScan();
            }

          }
        });
      },
      sendState : function ( state, chapter_id, question_id ) {

        $.ajax({
          url : this.settings.url,
          method : "POST",
          data : {
            "action" : "zmpzt_answer_question",
            "json" : JSON.stringify({
              "state" :  state,
              "response_id" : this.response_id,
              "scan_id" : this.scan_id,
              "chapter_id" : chapter_id,
              "question_id" : question_id,
              "status" : state.next_chapter == -1 ? 'complete' : 'in_progress'
            })


          },
          dataType : "json",
          success : function(data) {

            if ("success" in data && data.success === false ){

            } else {

            }

          }
        });
      },
      calculateState : function ( ) {
        var current_question = this.current_question;
        var next_question = current_question+1;
        var next_question_no_answer = next_question;
        var current_chapter = this.current_chapter;

        if ( typeof this.scan.chapter[this.current_chapter].question[next_question] == 'undefined' ) {
          //MJ: end of chapter
          next_question = 0;
          next_question_no_answer = 0;
          if ( typeof this.scan.chapter[this.current_chapter+1] == 'undefined' ) {
            //MJ: end of scan
            next_question = -1;
            next_question_no_answer = -1;
          }
        } else {
          if (typeof this.scan.chapter[this.current_chapter].question[this.scan.chapter[this.current_chapter].question[current_question].next_question] == 'undefined') {
            next_question_no_answer = next_question;
          } else {
            next_question_no_answer = parseInt(this.scan.chapter[this.current_chapter].question[current_question].next_question);
          }
        }
        //this.current_question= current_question;
        this.next_chapter = next_question > 0 ? current_chapter : next_question == 0 ? current_chapter+1 : -1 ;
        this.next_chapter_no_answer = next_question_no_answer > 0 ? current_chapter : next_question_no_answer == 0 ? current_chapter+1 : -1 ;
        this.next_question = next_question;
        this.next_question_no_answer = next_question_no_answer;
      },
      render_chapter : function () {
        //var _this = this;
        return function(text) {
          var data = this.scan.chapter[this.state.current_chapter];
          data.lambdas = this.lambdas;
          data.state = this.state;
          data.cluster_class = "cluster-"+(this.state.current_chapter+1);

          return Hogan.compile($( "#template_chapter" ).html()).render(data);

        };
      },
      render_chapter_feedback : function () {
        //var _this = this;
        return function(text) {
          var data = this.scan.chapter[this.state.current_chapter];
          data.lambdas = this.lambdas;
          data.state = this.state;
          data.cluster_class = "cluster-"+(this.state.current_chapter+1);

          return Hogan.compile($( "#template_chapter_feedback" ).html()).render(data);

        };
      },
      render_scan_feedback : function () {
        //var _this = this;
        return function(text) {
          var data = this.scan;
          data.lambdas = this.lambdas;
          data.state = this.state;
          data.cluster_class = "cluster-"+(this.state.current_chapter+1);

          return Hogan.compile($( "#template_scan_feedback" ).html()).render(data);

        };
      },
      render_scan_end_result : function () {
        //var _this = this;
        return function(text) {
          var data = this.report;
          data.lambdas = this.lambdas;
          data.state = this.state;

          return Hogan.compile($( "#render_scan_end_result" ).html()).render(data);

        };
      },
      render_question : function () {

        return function(text) {

          var data = this.question[this.state.current_question];
          data.lambdas = this.lambdas;
          data.state = this.state;

          if ( data.question_type == 'option') {

            return Hogan.compile($( "#template_extra_question" ).html()).render(data);

          } else {

            return Hogan.compile($( "#template_question" ).html()).render(data);
          }


        };
      },
      renderScan : function () {
        var _this = this;
        var data = {
          "scan" : _this.scan,
          "lambdas" : {
            "render_question" : _this.render_question,
            "render_chapter" : _this.render_chapter
          },
          "state" : this.getState()
        };
        this.$element.html ( Hogan.compile($ ( "#template_scan" ).html()).render ( data ) );
        this.$element.trigger ( "rendered", [this.getState()] );
      },
      renderChapterFeedback : function () {
        var _this = this;
        var data = {
          "scan" : _this.scan,
          "lambdas" : {
            "render_chapter_feedback" : _this.render_chapter_feedback
          },
          "state" : this.getState()
        };
        this.$element.html ( Hogan.compile($ ( "#template_scan" ).html()).render ( data ) );
        this.$element.trigger ( "rendered", [this.getState()] );
      },
      renderScanFeedback : function () {
        var _this = this;
        var data = {
          "scan" : _this.scan,
          "lambdas" : {
            "render_scan_feedback" : _this.render_scan_feedback
          },
          "state" : this.getState()
        };
        this.$element.html ( Hogan.compile($ ( "#template_scan" ).html()).render ( data ) );
        this.$element.trigger ( "rendered", [this.getState()] );
      },
      getState : function () {

        return {

          "previous_question" : this.previous_question,
          "previous_chapter" : this.previous_chapter,
          "current_chapter" : this.current_chapter,
          "current_question" : this.current_question,
          "next_question" : this.next_question,
          "next_question_no_answer" : this.next_question_no_answer,
          "next_chapter" : this.next_chapter,
          "next_chapter_no_answer" : this.next_chapter_no_answer,
          "current_answer" : this.current_answer,
          "question_type" : this.question_type

        };

      },
      getQuestion : function ( idxChapter, idxQuestion ) {

        return this.getChapter( idxChapter ).question[ idxQuestion ];

      },
      getCurrentQuestion : function () {

        return this.getQuestion ( this.current_chapter, this.current_question );

      },
      getChapter : function ( idxChapter ) {

        return this.scan.chapter[ idxChapter ];

      },
      getCurrentChapter : function ( ) {

        return this.getChapter( this.current_chapter );

      },
      setState : function ( state ) {

        this.previous_question = state.previous_question;
        this.previous_chapter = state.previous_chapter;
        this.current_chapter = state.current_chapter;
        this.current_question = state.current_question;
        this.next_question = state.next_question;
        this.next_question_no_answer = state.next_question_no_answer;
        this.next_chapter = state.next_chapter;
        this.next_chapter_no_answer = state.next_chapter_no_answer;
        this.current_answer = state.current_answer;
        this.question_type = state.question_type;

      },
      setStateForQuestion : function (  state  ){

        this.getQuestion ( state.current_chapter, state.current_question ).state = state;

      },
      answerQuestion : function ( val ) {

        this.current_answer = val;
        var state = this.getState();



        this.scan.chapter[this.current_chapter].question[this.current_question].state = state;
        this.sendState ( state, this.getCurrentChapter().id, this.getCurrentQuestion().id );

        //MJ: is end of chapter ?
        var next_question = val == -1 ? state.next_question_no_answer : state.next_question;
        var next_chapter = val == -1 ? state.next_chapter_no_answer : state.next_chapter;

        if ( next_question == -1 && next_chapter == -1 ) {

          this.current_chapter = -1;
          this.current_question = -1;

          this.renderScanFeedback ();

        } else if ( next_question == 0 && next_chapter != state.current_chapter ) {

          this.renderChapterFeedback ();

        } else {

          this.nextQuestion ( );

        }

      },
      nextQuestion : function ( ) {

        var question = this.next_question;
        var chapter = this.next_chapter;
        var question_type;



        if ( this.current_answer == -1 ) {

         question = this.next_question_no_answer;
         chapter = this.next_chapter_no_answer;

        }

        this.current_answer = 50;
        this.previous_chapter = this.current_chapter;
        this.previous_question = this.current_question;
        this.question_type= this.scan.chapter[chapter].question[question].question_type;


        if ( typeof this.scan.chapter[chapter].question[question].state == 'undefined' ){

         this.current_question = question;
         this.current_chapter = chapter;

        this.calculateState();

        } else {

         this.setState(this.scan.chapter[chapter].question[question].state);

        }

        this.renderScan();

      },
      previousQuestion : function ( ) {

        var question = this.previous_question;
        var chapter = this.previous_chapter;
        var state = this.scan.chapter[chapter].question[question].state;

        this.setState( state );

        this.renderScan();

      },
      destroy : function(){
        this.$element.empty();
        this.$element.data("plugin_"+pluginName,null);
        //delete this;
      },
      logmessage: function(message){
        if(this.settings.showDebug) console.log(message);
      }
    });

    $.fn[ pluginName ] = function ( methodOrOptions ) {

      var method = (typeof methodOrOptions === 'string') ? methodOrOptions : undefined;

      if (method) {
          var customPlugins: Array<any> = [];

          const getCustomPlugin = () => {
              var $el          = $(this);
              var customPlugin = $el.data("plugin_"+pluginName);

              customPlugins.push(customPlugin);
          }

          this.each(getCustomPlugin);

          var args    = (arguments.length > 1) ? Array.prototype.slice.call(arguments, 1) : undefined;
          var results: Array<any> = [];

          const applyMethod = (index) => {
              var customPlugin = customPlugins[index];

              if (!customPlugin) {
                  console.warn('$.customPlugin not instantiated yet');
                  console.info(this);
                  results.push(undefined);
                  return;
              }

              if (method && typeof customPlugin[method] === 'function') {
                  var result = customPlugin[method].apply(customPlugin, args);
                  results.push(result);
              } else {
                  console.warn('Method \'' + method + '\' not defined in $.customPlugin');
              }
          }

          this.each(applyMethod);

          return (results.length > 1) ? results : results[0];
      } else {
          var options = (typeof methodOrOptions === 'object') ? methodOrOptions : undefined;

          const init= () => {
              var $el          = $(this);
              var customPlugin = new ScanManager($el, options);

              $el.data("plugin_"+pluginName, customPlugin);
          }

          return this.each(init);
      }


    };

})( jQuery, window, document );
